export const INVOICE_SUCCESS = 'INVOICE_SUCCESS';
export const INVOICE_ERROR = 'INVOICE_ERROR';
export const LOAD_INVOICES = 'LOAD_INVOICES';
export const DELETE_INVOICE = 'DELETE_INVOICE';
export const UPDATE_INVOICE = 'UPDATE_INVOICE';
export const GET_INVOICES = 'GET_INVOICES';
export const SET_FILTER = 'SET_FILTER';
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const DOWNLOAD_INVOICE = 'DOWNLOAD_INVOICE';
